import theme from '../../theme';

export const RootBoxSx = {
  display: 'flex',
  flexDirection: 'column',

  '&.fullWidth': {
    width: '100%',
  },

  '&.multiline > div': {
    alignItems: 'flex-start',
  },

  'input[type=number]::-webkit-inner-spin-button ': {
    '-webkit-appearance': 'none',
    margin: 0,
  },
  'input[type=number]::-webkit-outer-spin-button': {
    '-webkit-appearance': 'none',
    margin: 0,
  },

  'input[type=number]': {
    '-moz-appearance': 'textfield',
  },
};

export const InputLabelSx = ({ type }: { type?: 'error' | 'warning' }) => ({
  color: `${type === 'error' ? theme.palette.error.main : type === 'warning' ? theme.palette.warning.main : theme.palette.customColors.gray[900]}`,
  fontSize: '14px',
  lineHeight: '20px',
  marginBottom: '4px',
  fontWeight: '500',

  '.MuiInputLabel-asterisk': {
    color: `${type === 'error' ? theme.palette.error.main : type === 'warning' ? theme.palette.warning.main : theme.palette.customColors.blue[600]}`,
    fontWeight: '500',
  },

  '&.Mui-disabled': {
    opacity: 0.5,
    color: `${theme.palette.customColors.gray[900]}`,

    '.MuiInputLabel-asterisk': {
      color: `${theme.palette.customColors.blue[600]}`,
      opacity: 0.5,
    },
  },
});

export const lockedTextFieldSx = {
  '&.MuiInputBase-root': {
    cursor: 'default',
    pointerEvents: 'none',
  },

  '&.MuiInputBase-root input, &.MuiInputBase-root textarea': {
    cursor: 'default',
  },

  '&.MuiOutlinedInput-root:not(.Mui-disabled):not(.Mui-error):hover .MuiOutlinedInput-notchedOutline':
    {
      borderColor: '#d9d9de',
    },

  '&.MuiOutlinedInput-root:not(.Mui-disabled):not(.Mui-error).Mui-focused .MuiOutlinedInput-notchedOutline':
    {
      borderColor: '#d9d9de',
      boxShadow: 'none',
    },
};

export const OutlinedInputSx = {
  flexGrow: 1,
  '&.Mui-disabled': {
    backgroundColor: `${theme.palette.customColors.gray[100]}`,
  },

  '& .MuiInputBase-input': {
    fontSize: '16px',
    padding: '10.5px 16px 10.5px 16px',
    '&.Mui-disabled': {
      backgroundColor: `${theme.palette.customColors.gray[100]}`,
    },
    '&::-ms-reveal': {
      display: 'none',
    },
    '&::-ms-clear': {
      display: 'none',
    },
  },

  '&.MuiInputBase-multiline': {
    padding: '0',
  },

  '& input:-webkit-autofill': {
    WebkitBoxShadow: `0px 0px 0px 40rem ${theme.palette.common.white} inset`,
    WebkitTextFillColor: 'inherit',
    transition: 'background-color 5000s ease-in-out 0s',
  },

  '& input:-webkit-autofill:hover': {
    WebkitBoxShadow: `0px 0px 0px 40rem ${theme.palette.common.white} inset`,
  },

  '& input:-webkit-autofill:focus': {
    WebkitBoxShadow: `0px 0px 0px 40rem ${theme.palette.common.white} inset`,
  },

  '&.Mui-disabled input:-webkit-autofill': {
    WebkitBoxShadow: `0px 0px 0px 40rem ${theme.palette.customColors.gray[100]} inset !important`,
    WebkitTextFillColor: `${theme.palette.text.disabled} !important`,
  },

  '&.Mui-disabled input:-webkit-autofill:hover': {
    WebkitBoxShadow: `0px 0px 0px 40rem ${theme.palette.customColors.gray[100]} inset !important`,
  },

  '&.Mui-disabled input:-webkit-autofill:focus': {
    WebkitBoxShadow: `0px 0px 0px 40rem ${theme.palette.customColors.gray[100]} inset !important`,
  },

  '&.MuiInputBase-sizeSmall .MuiInputBase-input': {
    padding: '6px 12px',
    fontSize: '14px',
  },
  '&.MuiOutlinedInput-root.MuiInputBase-sizeSmall .MuiAutocomplete-input': {
    padding: '2.5px 4px 5.5px 8px !important',
  },

  '&.MuiInputBase-adornedStart .MuiInputBase-input': {
    paddingLeft: '2.5px',
  },

  '& .MuiInputBase-input::placeholder': {
    opacity: 1,
    color: `${theme.palette.customColors.gray[400]}`,
  },

  '&.MuiInputBase-sizeSmall .MuiInputBase-input::placeholder': {
    fontSize: '14px',
  },

  '& .MuiOutlinedInput-notchedOutline': {
    border: `1px solid ${theme.palette.customColors.gray[200]}`,
    borderRadius: '6px',
  },

  '&.MuiOutlinedInput-root.Mui-disabled:hover .MuiOutlinedInput-notchedOutline':
    {
      borderColor: `${theme.palette.customColors.gray[300]}`,
    },

  '&.MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline': {
    borderColor: `${theme.palette.customColors.gray[300]}`,
  },

  '&:not(.Mui-disabled):not(.Mui-error):not(.warning):hover .MuiOutlinedInput-notchedOutline':
    {
      borderColor: `${theme.palette.customColors.gray[400]}`,
    },

  '&:not(.Mui-disabled):not(.Mui-error):not(.warning).Mui-focused .MuiOutlinedInput-notchedOutline':
    {
      boxShadow: `0px 0px 4px 0px ${theme.palette.customColors.blue[450]}`,
      borderColor: `${theme.palette.customColors.blue[500]}`,
    },

  '&.Mui-disabled svg': {
    opacity: 0.5,
  },

  '& .endAdornmentContainer': {
    display: 'flex',
    alignItems: 'center',

    '.separator': {
      margin: '0 4px 0 0',
      width: '1px',
      height: '24px',
      backgroundColor: `${theme.palette.customColors.gray[200]}`,
    },
  },

  '&.Mui-error': {
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.error.main,
    },

    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.error.main,
    },

    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      boxShadow: 'none',
      borderColor: theme.palette.error.main,
    },

    '.endAdornmentContainer .separator': {
      margin: '0 4px 0 8px',
    },
  },
  '&.MuiOutlinedInput-root.warning': {
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.warning.main,
    },

    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.warning.main,
    },

    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      boxShadow: 'none',
      borderColor: theme.palette.warning.main,
    },

    '.endAdornmentContainer .separator': {
      margin: '0 4px 0 8px',
    },
  },
};
